import React from 'react';

import './ChangeCollectorDetails.css';


class ChangeCollectorDetails extends React.Component{
constructor(props){
  super(props);
  this.state = {
    collectorNo:'',
    thecollectorNo:'',
    collectorName:'',
    collectorSurname:'',
    collectorGender:'',
    collectorRef:'',
    collectorRel:'',
    collectorCell:'',
    collectorEmail:'',
    collectorPin:'',
    part2:false,
    showNxt:false,
  }
}


componentDidMount(){
  fetch('https://schoolportal.appsdesign.co.za/get_collector/' + localStorage.getItem('schoolToken'))
  .then((response) => response.json())
  .then((responseJson) => {
console.log(responseJson[0])
    this.setState({
      data: responseJson,

}, function(){

    });
console.log(this.state.data)
  })
  .catch((error) =>{
    console.error(error);
  });

  }


      deleteCol = (val) =>{
        fetch('https://schoolportal.appsdesign.co.za/delete_col/' + val)
        .then(() => {
        alert('class data has been deleted')
        })
        .catch((error) =>{
          console.error(error);
        });

        }







//   changeCollectorPin = (event) =>{
//
//     var pin = event.target.value
//
//     this.setState({collectorPin:pin});
// }


  changeCollectorEmail = (event) =>{

  this.setState({collectorEmail:event.target.value});

  }




  changeCollectorCell = (event) =>{
    var number = event.target.value;

    number = number.charAt(0) === '0' ? '+27'+number.substr(1): (number.charAt(0) === '+' ? number  : '+27' + number);
  this.setState({collectorCell:number});

  }



  changeCollectorNo = (event) =>{

    var collectno = event.target.value;
      if(collectno.length === 13){
        document.getElementById("overlay").style.display = "block";
      //Check duplicates
      fetch('https://schoolportal.appsdesign.co.za/colno/' + collectno +'/'+ localStorage.getItem('schoolToken'))
      .then((response) => response.json())
      .then((responseJson) => {
      if(responseJson[0] !== undefined){
        //if no match then:

        //else :
      document.getElementById("overlay").style.display = "none";
        alert('The collector no is unavailable, please try another.')

      }
      else{
        document.getElementById("overlay").style.display = "none";
      alert('collector no ok');


      this.setState({collectorNo:collectno});
      }


      })
      .catch((error) =>{
        console.error(error);
      });


}

  }

  changeCollectorName = (event) =>{

  this.setState({collectorName:event.target.value});

  }

  changeCollectorSurname = (event) =>{

  this.setState({collectorSurname:event.target.value});

  }

  changeCollectorGender = (event) =>{

  this.setState({collectorGender:event.target.value});

  }

  changeCollectorRel = (event) =>{

  this.setState({collectorRel:event.target.value});

  }

  changeCollectorRef = (event) =>{

  this.setState({collectorRef:event.target.value});

  }





updateCollector = () =>{

alert(`Updating Collector \n\r
       Collector no: ${this.state.collectorNo} \n\r
       Collector name: ${this.state.collectorName} \n\r
       Collector surname: ${this.state.collectorSurname} \n\r
       Collector gender: ${this.state.collectorGender} \n\r`


     )
     fetch('https://schoolportal.appsdesign.co.za/update_collector', {
         method: 'post',
         headers: {'Content-Type' : 'application/json'},
         body: JSON.stringify({
             name: this.state.collectorName,
             surname: this.state.collectorSurname,
             gender: this.state.collectorGender,
             refrence: this.state.collectorRef,
             cell: this.state.collectorCell,
             email: this.state.collectorEmail,
             text: this.state.collectorNo,
             code: this.state.thecollectorNo,
             deleted: false,
             old_cousin: "",
             fc_color: "",
             first_job: "",
             birth_town: ""

   })
     })
     .then(response =>{
this.setState({
  collectorNo:'',
  collectorName:'',
  collectorSurname:'',
  collectorGender:'',
  collectorRef:'',
  collectorRel:'',
  collectorCell:'',
  collectorEmail:'',
  part2:false,
  showNxt:false,
})


var elements = document.getElementsByTagName("input");
for (var ii=0; ii < elements.length; ii++) {
  if (elements[ii].type === "text") {
    elements[ii].value = "";
  }
}

      alert('Collector Updated')

     })

}


  changeToPart2 = () =>{


  return this.state.data.map(val =>{

  if (val.name.toLowerCase().includes(this.state.collectorName.toLowerCase()) && val.surname.toLowerCase().includes(this.state.collectorSurname.toLowerCase())){

    this.setState({
      collectorNo:val.code,
      thecollectorNo:val.code,
      collectorName:val.name,
      collectorSurname:val.surname,
      collectorGender:val.gender,
      collectorRef:val.reference,
      collectorRel:val.relationship,
      collectorCell:val.cell,
      collectorEmail:val.email,
      collectorPin:val.code,
      part2:true,
      showNxt:true

    });


  }

return false;

  })

}


changeCancel = () =>{

this.setState({part2:false});

  this.setState({collectorNo:''});

  this.setState({collectorName:''});

  this.setState({collectorSurname:''});



}



render(){



  let collector;

  if(this.state.part2 && this.state.showNxt){

    collector = this.state.data.map( (collector,i) => {
  console.log(collector);
var colfname = collector.name +' '+ collector.surname;
var checkfname = this.state.collectorName.toLowerCase() +' '+ this.state.collectorSurname.toLowerCase();

    if (colfname.toLowerCase().includes(checkfname)){

  return (

<div key={i} className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>
      <div id="overlay">
        <div id="text">Validating, please wait ....</div>
      </div>

    <h1>Change Collector Details</h1>
<div>
    <label htmlFor="collectorCode" style={{marginRight:40}}>
    Collector No</label>
    <input
    type="text"
    placeholder="Collector Code"
    id="chollectorCode"
    defaultValue={collector.code}
    className="pa2 ma2"
    onKeyUp={this.changeCollectorNo}
    />
    <br/>

    <label htmlFor="collectorName" style={{marginRight:20}}>
    Collector Name</label>
    <input
    type="text"
    placeholder="Collector Name"
    id="collectorName"
    defaultValue={collector.name}
    className="pa2 ma2"
    onKeyUp={this.changeCollectorName}
    />
    <br/>

    <label htmlFor="collectorSurname">
    Collector Surname</label>
    <input
    type="text"
    placeholder="Collector Surname"
    id="collectorSurname"
    defaultValue={collector.surname}
    className="pa2 ma2"
    onKeyUp={this.changeCollectorSurname }
    />
    <br/>



      <label htmlFor="collectorGender">
      Child Gender
    <select
    id="collectorGender"
    className="pa2 ma2"
    defaultValue={collector.gender}
    onChange={this.changeCollectorGender}
      >
    <option value="">Please select</option>
      <option value="male">Male</option>
        <option value="female">Female</option>
          <option value="other">Other</option>
          </select>
      </label><br/>

{

      //   <label htmlFor="collectorRef">
      //   Collector Reference
      // <input
      // type="text"
      // placeholder="Collector Reference"
      // id="collectorRef"
      // className="pa2 ma2"
      // defaultValue={collector.refrence}
      // onKeyUp={this.changeCollectorRef}
      // />
      //   </label><br/>


//        <label htmlFor="collectorRel">
//        Collector Relationship
//      <input
//      type="text"
//      placeholder="Collector Relationship"
//      id="collectorRel"
//      className="pa2 ma2"
//      defaultValue={collector.relationship}
//      onKeyUp={this.changeCollectorRel}
//      />
//        </label><br/>
}






        <label htmlFor="collectorCell" style={{marginRight:40}}>
        Collector Cell</label>
        <input
        type="text"
        placeholder="Collector Cell"
        id="collectorCell"
        className="pa2 ma2"
        defaultValue={collector.cell}
        onKeyUp={this.changeCollectorCell}
        />
        <br/>




                <label htmlFor="collectorEmail" style={{marginRight:30}}>
                Collector Email</label>
                <input
                type="text"
                placeholder="Collector Email"
                id="collectorEmail"
                className="pa2 ma2"
                defaultValue={collector.email}
                onKeyUp={this.changeCollectorEmail}
                />
                <br/>









      <button className="br3 ma2 pa3 bg-orange br-orange" onClick={this.changeCancel}>Cancel</button> &nbsp;
      <button className="br3 ma2 pa3 bg-red br-red" onClick={() => this.deleteCol(collector._id)}>Delete</button> &nbsp;
      <button className="br3 ma2 pa3 bg-blue br-blue" onClick={this.updateCollector}>Save</button>
      </div>
  </div>
    );


    }
//this.setState({showNxt:false});
return false;


    })



  }

















return(


  !this.props.isAuthed ? <h1> your out, sorry not authenticated </h1>


  :(
    !this.state.part2 ?
  <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>
<h1>Change Collector details</h1>

<div>
    <label htmlFor="collectorName" style={{marginRight:20}}>
    Collector Name</label>
  <input
  type="text"
  placeholder="Collector Name"
  id="collectorName"
  className="pa2 ma2"
  onKeyUp={this.changeCollectorName}
  />
  <br/>

    <label htmlFor="collectorSurname" style={{marginRight:0}}>
    Collector Surname</label>
  <input
  type="text"
  placeholder="Collector Surname"
  id="collectorSurname"
  className="pa2 ma2"
  onKeyUp={this.changeCollectorSurname}
  />
  <br/>



    <button className="br3 pa3 bg-blue br-blue" onClick={this.changeToPart2}>Continue</button>
</div>


    </div> :
    <div>
  {collector}
    </div>
)
)
}

}

export default ChangeCollectorDetails;



// WEBPACK FOOTER //
// ./src/components/ChangeCollectorDetails/ChangeCollectorDetails.js